//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      legend: {
        top: 20,
        textStyle: {
          color: 'white',
          //这里是改变字体颜色
          fontSize: 13 //字体大小

        }
      },
      data: {
        'columns': ['name', 'grade_total'],
        'rows': [{
          'dt': '消费者',
          'grade': 1
        }, {
          'dt': '店长',
          'grade': 2
        }, {
          'dt': '一品达人',
          'grade': 3
        }, {
          'dt': '一品高达',
          'grade': 4
        }, {
          'dt': '大批发商',
          'grade': 5
        }]
      },
      yAxis: [{
        axisLabel: {
          show: true,
          textStyle: {
            color: 'white',
            //这里是改变字体颜色
            fontSize: 13 //字体大小

          }
        },
        splitLine: {
          show: false
        }
      }],
      xAxis: [{
        name: '日期',
        axisLabel: {
          show: false,
          textStyle: {
            color: 'white',
            fontSize: 0
          }
        },
        splitLine: {
          show: false
        }
      }],
      'grid': {
        'backgroundColor': 'transparent',
        'borderColor': 'transparent',
        'borderWidth': 0,
        'bottom': 60,
        'height': 'auto',
        'left': '10%',
        'right': '10%',
        'shadowBlur': 0,
        'shadowColor': 'rgba(0, 0, 0, 0)',
        'shadowOffsetX': 0,
        'shadowOffsetY': 0,
        'show': false,
        'tooltip': {
          'show': true
        },
        'top': 60,
        'width': 'auto'
      },
      'settings': {
        'area': true,
        'digit': 2,
        'itemStyle': {
          'borderColor': '#000',
          'borderType': 'solid',
          'borderWidth': 0,
          'shadowBlur': 0,
          'shadowColor': 'rgba(0, 0, 0, 0)',
          'shadowOffsetX': 0,
          'shadowOffsetY': 0
        },
        'labelMap': {
          'grade_total': '各等级人数'
        },
        'showLine': [],
        'type': 'pie',
        'xAxisType': 'category',
        'yAxisType': 'normal'
      }
    };
  },
  methods: {
    update: function update(value) {
      this.data = {
        'columns': ['name', 'grade_total'],
        'rows': value
      };
    }
  }
};